var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.25V10.3333H10.9167M6.25 1H9.75M8 3.33333C6.14348 3.33333 4.36301 4.07083 3.05025 5.38359C1.7375 6.69634 1 8.47682 1 10.3333C1 12.1898 1.7375 13.9703 3.05025 15.2831C4.36301 16.5958 6.14348 17.3333 8 17.3333C9.85652 17.3333 11.637 16.5958 12.9497 15.2831C14.2625 13.9703 15 12.1898 15 10.3333C15 8.47682 14.2625 6.69634 12.9497 5.38359C11.637 4.07083 9.85652 3.33333 8 3.33333Z",
    stroke: "#8E97A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clockIcon.bdd345e3cbdd41621d46671b00431f17.svg";
export { ForwardRef as ReactComponent };